/**
 *
 * CentricLayout Component
 *
 */

import React, { ReactElement } from "react";
import classnames from "classnames";
import { stylize } from "@envestnet/envreact-component-library";
import withIntl from "utils/withIntl";
import styles, { Styles } from "./styles";

interface InjectedProps extends Styles {
  /** Internal - injected from WithStyles */
  innerRef?: React.RefObject<HTMLDivElement>;
}

interface DefaultProps {
  // Default props should always be required props, i.e. no ? indicating it's optional
  // The default values are specified below
}

export interface CentricLayoutProps extends DefaultProps {
  /** CSS class name to be applied to top level component */
  className?: string;

  /** Inline style object to be applied to top level component */
  style?: React.CSSProperties;

  /** Description of this prop */
  children: ReactElement<any, any>;
}

type Props = InjectedProps & CentricLayoutProps;

const CentricLayout = (props: Props) => {
  const { classes, style, className, innerRef, children } = props;

  return (
    <div
      ref={innerRef}
      className={classnames(className, classes.container)}
      style={style}
    >
      <div>{children}</div>
    </div>
  );
};

export default withIntl(stylize<Props, DefaultProps>(styles)(CentricLayout));
